let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZsBL")).then(() => parcelRequire('7UCC9'));